module.exports = "https://static.wmbcdn.com/uniweb/images/b5ad4e7ae477c66754c88a0d3b9fb4be.svg";